const GamesContestsTranslations = {
  en: {
    heading1: 'Contests',
    heading2: 'Play and win points',
    tab1: 'Contests23',
    tab2: 'Games',
    gameStatic1: 'GISP Quiz 2',
    gameStatic2: 'GISP Quiz 4',
    bannerHeading: 'CHALLENGE',
    bannerSubHeading: 'Cyber',
    bannerContent: "Think you can outsmart a hacker? Prove it in our cyber games!"
  },
  es: {
    heading1: 'Concursos',
    heading2: 'Juega y gana puntos',
    tab1: 'Concursos',
    tab2: 'Juegos',
    gameStatic1: 'Cuestionario GISP 2',
    gameStatic2: 'Cuestionario GISP 4',
    bannerHeading: 'DESAFÍO',
    bannerSubHeading: 'Cibernético',
    bannerContent: "¿Crees que puedes burlar a un hacker? ¡Demuestra en nuestros juegos cibernéticos!"
  },
  pt: {
    heading1: 'Concursos',
    heading2: 'ogue e ganhe pontos',
    tab1: 'Concursos',
    tab2: 'Jogos',
    gameStatic1: 'Quiz GISP 2',
    gameStatic2: 'Quiz GISP 4',
    bannerHeading: 'DESAFIO',
    bannerSubHeading: 'Cibernético',
    bannerContent: "Acha que pode enganar um hacker? Prove nos nossos jogos cibernéticos!"
  },
  zh: {
    heading1: '比赛',
    heading2: '玩游戏赢取积分',
    tab1: '比赛',
    tab2: '游戏',
    gameStatic1: 'GISP测验2',
    gameStatic2: 'GISP测验4',
    bannerHeading: '挑战',
    bannerSubHeading: '网络',
    bannerContent: "你认为你能智胜黑客吗？在我们的网络游戏中证明吧！"
  },
};

export default GamesContestsTranslations;
